import { DateTime } from 'luxon'

export const buildPlanPinsFilter = ({ projectId, planId }) => ({
  projectId,
  entity: 'Pins',
  conjunction: 'All',
  predicates: [{ attribute: 'Plan', operator: 'Is', values: [planId] }]
})

export const buildExportFileName = (projectName, planName) =>
  `${DateTime.now().toFormat('yyyy-MM-dd')}-${projectName.replace(/\s/g, '_')}-${planName.replace(/\s/g, '_')}.jpg`
